import React from "react";

import rollbar from "lib/rollbar";

type Props = {
    children: React.ReactNode;
    fallback?: React.ReactNode;
    hideContainer?: boolean;
    onError?: (error: Error) => void;
};

type State = {
    hasError: boolean;
};

class ErrorContainer extends React.Component<Props, State> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        rollbar.error(error);
        if (this.props.onError) this.props.onError(error);
    }

    renderContainer() {
        if (this.props.hideContainer) return this.props.children;
        return <div className="app-container">{this.props.children}</div>;
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) return this.props.fallback;
            return (
                <div className="app-container app-container--error">
                    <div className="portal-container">
                        <div className="portal-container__content">
                            <div className="portal-section-block">
                                We encountered an error displaying this page. If you continue to
                                receive this error, please contact{" "}
                                <strong>employers@workstep.com</strong>. Be sure to provide any
                                relevant details that led to the problem, including which page you
                                were on and which actions you were taking.
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return this.renderContainer();
    }
}

export default ErrorContainer;
